module.exports = __webpack_public_path__ + "assets/img/img_bj.5adc0359.png";